import React from 'react';
import { connect } from 'react-redux';
import { Button, Modal } from 'react-bootstrap';
import ACSplitTypeDetail from '../../components/ac_split_type/ACSplitTypeDetail';

import { translate } from 'react-i18next';
import { defaultRejectHandler, toCoolingCap } from '../../utils/utility';
import { createACSpiltType } from '../../redux/ac_split_type/ac_split_type_actions';

class ACSplitTypeCreateModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
    };

    this.acDetail = undefined;
  }

  onSaveHandler() {
    const newAC = this.acDetail.getWrappedInstance().getWrappedInstance().getACData();
    this.props.createAC(newAC);
  }

  render() {
    const { isCreating, errorMessage, acDetail, createAC, t, ...newProps } = this.props;
    const { isSubmittable } = this.state;
    return (
      <Modal
        {...newProps}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('create a/c split type')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ACSplitTypeDetail
            ref={ref => (this.acDetail = ref)}
            onValid={isValid => this.setState({ isValid })}
            onDirty={isDirty => this.setState({ isDirty })}
            onSubmittable={isSubmittable => this.setState({ isSubmittable })}
            fieldErrors={errorMessage}
            onSubmit={() => !this.props.isCreating && !this.props.isCreated && this.onSaveHandler()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="air-conditioning-split-type-submit-create"
            disabled={!isSubmittable || isCreating}
            onClick={() => this.onSaveHandler()}
          >
            {isCreating ? `${t('saving')}...` : t('save')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state, props) => ({
  errorMessage: state.ac.splitType.errorMessage,
  isCreating: state.ac.splitType.isCreating,
  acDetail: props.ac && state.ac.splitType.objects[props.ac.id],
});

const mapDispatchToProps = dispatch => ({
  createAC: ac =>
    defaultRejectHandler(
      dispatch(
        createACSpiltType(
          ac.name,
          ac.type,
          ac.brand_id,
          ac.SEER,
          toCoolingCap(ac.cooling_capacity, ac.unit),
          ac.unit,
          ac.power_required,
          ac.description,
          ac.image,
        ),
      ),
    ),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(ACSplitTypeCreateModal),
);



// WEBPACK FOOTER //
// ./src/modal/ac_split_type/ACSplitTypeCreateModal.js